module.exports = __webpack_public_path__ + "img/Booking_com_tcm583-4430305 2 copy.cf8305d8.svg";